const Loader = () => {
  return (
    <div className="justify-content-center">
      <div className="pacterpillar">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  )
}

export default Loader
